// extracted by mini-css-extract-plugin
export default {"myswiper":"SwiperUiHero_myswiper__gMwRu"};